import React from "react";

const HTMLCut = (props: { children?: React.ReactNode }) => <div data-component="cut">{props.children}</div>;

export default HTMLCut;
